import React from "react";
import BaseModal from "../../../../../components/ui/BaseModal";
import BaseFeedback from "../../../../../components/ui/BaseFeedback";
import BaseDataTableV2 from "../../../../../components/ui/BaseDataTableV2";
import { fetchAllFeedbacksByUserId } from "../../../../../services/api/feedback";
import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";

const FeedbackListingModal = ({ open, close }) => {
  const { id: userId } = useParams();
  const {
    isPending: isfetchAllFeedbacksByUserIdApiLoading,
    refetch: refetchAllFeedbacksByUserId,
    data: feedbacksData,
  } = useQuery({
    queryKey: ["feedbackListing", userId],
    queryFn: () => fetchAllFeedbacksByUserId(userId),
    enabled: !!userId,
  });

  const columns = [
    {
      field: "id",
      headerName: "",
      flex: 1,
      renderCell: (params) => {
        return (
          <div className="m-[14px] w-full">
            <BaseFeedback
              workOrder={{
                title: params.row.title,
                category: params.row.category,
                address: params.row.address,
                distance: params.row.distance,
                status: params.row.status,
              }}
              feedbackReceived={params?.row?.feedbackReceived}
              feedbackGiven={params?.row?.feedbackGiven}
              isDefaultOpen={false}
            />
          </div>
        );
      },
    },
  ];
  return (
    <BaseModal
      className="-top-[200px]"
      open={open}
      close={() => close(false)}
      style={{ width: "1620px" }}
    >
      <div className="sticky top-0 z-10 bg-light w-full py-4 px-4 border-bottom  flex justify-between">
        <h5 className="text-dark font-medium">Feedbacks</h5>
      </div>

          <BaseDataTableV2
            slots={{
              columnHeaders: () => null,
            }}
            className="max-h-[calc(100vh-100px)] overflow-auto "
            getRowHeight={() => "auto"}
            rowHeight={null}
            columns={columns}
            data={feedbacksData?.data}
            isLoading={isfetchAllFeedbacksByUserIdApiLoading}
            //   disableColumnResize={false}
            disableRowSelectionOnClick={true}
            //   checkboxSelection
            // hideFooter={false}
            //   pagination
            //   paginationMode="server"
            //   paginationModel={paginationModel}
            //   onPaginationModelChange={handlePaginationChange}
            //   pageSizeOptions={[10, 20, 50, 100]}
            //   rowCount={rowCount}
          />
    </BaseModal>
  );
};

export default FeedbackListingModal;
